import {NgModule} from '@angular/core';
import {LicensesCertificationsPageComponent} from './licenses-certifications-page.component';
import {PageCommonModule} from '../shared/page-common.module';
import {FormsModule} from '../../components/forms/forms.module';
import {NgbDatepickerModule} from '@ng-bootstrap/ng-bootstrap';
import {StepScreenModule} from '../shared/step/step-screen.module';
import {BoardSelectionScreenComponent} from './steps/board/selection/board-selection-screen.component';
import {AbmsBoardScreenComponent} from './steps/board/abms/abms-board-screen.component';
import {AbpsBoardScreenComponent} from './steps/board/abps/abps-board-screen.component';
import {AbmsBoardSubspecialtyScreenComponent} from './steps/board/abms-subspecialty/abms-board-subspecialty-screen.component';
import {SpecialtyExaminationScreenComponent} from './steps/board/specialty-examination/specialty-examination-screen.component';
import {ProfessionalLicenseScreenComponent} from './steps/professional/professional-license/professional-license-screen.component';
import {PermitScreenComponent} from './steps/professional/permit/permit-screen.component';
import {InactiveLicensesInformationScreenComponent} from './steps/inactive/inactive-licenses-information-screen.component';
import {DeaRegistrationScreenComponent} from './steps/dea/dea-registration/dea-registration-screen.component';
import {DeaRegistrationInformationScreenComponent} from './steps/dea/dea-registration-information/dea-registration-information-screen.component';
import {LifeCertificationScreenComponent} from './steps/lifecertification/life-certification-screen.component';
import {AccordionModule} from '../../components/accordion/accordion.module';
import {LicensingExaminationScreenComponent} from './steps/licensingexamination/licensing-examination-screen.component';
import {ContinuingMedicalEducationScreenComponent} from './steps/cme/continuing-medical-education-screen.component';
import {AoaBoardScreenComponent} from './steps/board/aoa/aoa-board-screen.component';
import {AoaBoardSubspecialtyScreenComponent} from './steps/board/aoa-subspecialty/aoa-board-subspecialty-screen.component';
import {FileUploaderModule} from '../../components/files/file-uploader/file-uploader.module';
import {FileListModule} from '../../components/files/file-list/file-list.module';

/**
 * Created by Rodrigo Quesada on 24/11/16.
 */
@NgModule({
    imports: [
        PageCommonModule,
        FormsModule,
        StepScreenModule,
        NgbDatepickerModule,
        AccordionModule,
        FileListModule,
        FileUploaderModule
    ],
    declarations: [
        LicensesCertificationsPageComponent,
        BoardSelectionScreenComponent,
        AbmsBoardScreenComponent,
        AbmsBoardSubspecialtyScreenComponent,
        AbpsBoardScreenComponent,
        AoaBoardScreenComponent,
        AoaBoardSubspecialtyScreenComponent,
        SpecialtyExaminationScreenComponent,
        ProfessionalLicenseScreenComponent,
        PermitScreenComponent,
        InactiveLicensesInformationScreenComponent,
        DeaRegistrationScreenComponent,
        DeaRegistrationInformationScreenComponent,
        LifeCertificationScreenComponent,
        LicensingExaminationScreenComponent,
        ContinuingMedicalEducationScreenComponent
    ]
})
export class LicensesCertificationsPageModule {
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/pages/licenses-certifications/licenses-certifications-page.module.ts